import React from 'react'
import { Box } from '@mui/material'
import ManutenzioneForm from './ManutenzioneForm'
import { useSelector } from 'react-redux'


export const ManutenzioneSlider = ({cantine,setCantine}) => {
    const singleData = useSelector((store) => store?.manutenzione?.singleManutenzione)
    console.log(singleData, "datasingle123")
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Manutenzione</h2>
            </Box>
            <ManutenzioneForm cantine={cantine} setCantine={setCantine} singleData={singleData} />
        </Box>
    )
}
